// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.one-line {
  justify-content: space-between;
  display: flex;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.vue-treeselect__control {
  background-color: transparent !important;
  border-radius: 0px !important;
  border-bottom-width: 0.5px !important;
  border-color: rgba(0, 0, 0, 0.87) !important;
  border-top: none;
  border-left: none;
  border-right: none;
  padding-left: 0px;
}
.v-icon material-icons theme--light v-alert__icon {
  margin-right: 16px;
}
.tree-select {
  font-size: 16px;
  margin: 0;
  border-style: none;
  padding: 0px;
}
.vue-treeselect__input-container,
.vue-treeselect__single-value {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.v-alert__icon {
  margin-right: 0px;
}
.maping-alert {
  position: relative;
  margin-top: 5px;
}
.vue-treeselect__placeholder {
  padding: 0px !important;
  font-family: 'Noto Sans', Avenir, Helvetica, Arial, sans-serif !important;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.54);
  height: 32px;
  font-weight: 400;
  text-align: start;
  text-indent: 0px;
}
.maping-alert >>> .alert .alert__icon.v-icon {
  width: 0px;
}
.maping-alert >>> .v-alert {
  border: 0px !important;
  position: relative;
  top: -5px;
}
.waring-maping {
  position: absolute !important;
  left: -10px;
  bottom: -30px;
}
.policy-selector-content {
  position: relative;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
